import React from 'react'

export default function ArticleCategoryBatch({ title }) {
  return (
    <div className={`batch px-3 px-md-4 py-1 br-5 font-weight-bold font-14 d-inline-block ${title.toLowerCase()}`}>
      {title}
    </div>
  )
}
